<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-07 09:16:43
-->
<template>
  <div class="app-container">
    <div class="header">
      <div class="header-serach">
        <el-form :inline="true" :model="ruleform">
          <el-form-item label="">
            <el-input
              v-model="ruleform.assemblyName"
              placeholder="搜索名称"
              @keyup.enter.native="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select
              v-model="ruleform.areaCode"
              placeholder="请选择区域"
              @change="getPoss"
              :disabled="disabled"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.code"
                :label="item.county"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="ruleform.videoTime"
              type="datetimerange"
              @change="getPoss"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="创建开始时间"
              end-placeholder="创建开始时间"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="addPru" @click="add">添加</div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column label="序号" type="index" align="center" width="50">
      </el-table-column>
      <el-table-column
        prop="assemblyName"
        label="名称"
        width="350"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="areaName"
        label="所属区域"
        align="center"
      ></el-table-column>
      <el-table-column prop="fileName" label="文件" align="center">
        <template slot-scope="scope">
          <a
            style="cursor: pointer; color: #1890ff"
            :href="scope.row.fileUrl"
            target="_blank"
            >{{ scope.row.fileName }}</a
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span
            style="cursor: pointer; margin-right: 10px; color: #1890ff"
            @click="operationTopping(scope.row.id, scope.row.isTop)"
            >{{ scope.row.isTop ? '取消置顶' : '置顶' }}</span
          >
          <span
            style="cursor: pointer; margin-right: 10px; color: #1890ff"
            @click="edit(scope.row.id)"
            >编辑</span
          >
          <span
            style="margin-right: 10px; cursor: pointer; color: #1890ff"
            @click="deleteEntTrain(scope.row.id)"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
    <el-drawer
      :title="name"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="content">
        <el-form
          :model="ruleform1"
          :rules="rules"
          label-position="top"
          ref="ruleform1"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="请输入名称" prop="assemblyName">
            <el-input
              v-model="ruleform1.assemblyName"
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="请选择区域" prop="areaCode">
            <el-select
              v-model="ruleform1.areaCode"
              placeholder="请选择区域"
              @change="getPoss"
              :disabled="disabled"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.code"
                :label="item.county"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="请上传封面" prop="imageUrl" ref="imageId">
            <el-upload
              :class="{ hide: hideUpload }"
              :headers="uploadHeader"
              :action="uploadFileByContentType"
              :before-upload="beforeAvatarUpload"
              list-type="picture-card"
              :on-change="handleChange"
              :limit="1"
              :file-list="fileList"
              accept=".jpg, .png, .jpeg .bmp .tiff"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="docSuccess"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="ruleform1.imageUrl" alt="" />
            </el-dialog>
            <div class="el-upload__tip">上传png、jpg、bmp、tiff等格式图片</div>
            <!-- <div>建议尺寸750*240或比例25:8，小于1M的JPG、PNG格式图片</div> -->
          </el-form-item>
          <el-form-item label="附件" prop="fileUrl" ref="fileId">
            <el-upload
              ref="uploader"
              :action="uploadFileByContentType2"
              :before-upload="beforeAvatarUpload1"
              :on-remove="handleRemove1"
              multiple
              accept=".pdf"
              :headers="uploadHeader"
              :limit="1"
              :file-list="fileList1"
              :on-success="docSuccess1"
              :on-exceed="handleExceed"
            >
              <el-button icon="el-icon-upload2" :loading="loading">{{
                text
              }}</el-button>
              <div slot="tip" class="el-upload__tip">
                支持上传PDF格式的电子文档，最多一个，不超过500M
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="ruleform1.note"
              maxlength="200"
              show-word-limit
            ></el-input>
            <div style="font-size: 12px; color: #606266">
              注：上传之后，请在移动端查看并阅读
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleform1')"
              >确 定</el-button
            >
            <el-button @click="handleClose()">取 消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getArea } from '@api/activityCenter/activityCenter'
import {
  listAssemblyData,
  deleteAssembly,
  getAssemblyById,
  updateOrInsertAssembly,
  uploadFileByContentType2,
  getUploadProcess,
  updateTopOperate
} from '@api/policyCompilation/policyCompilation'
import { uploadFileByContentType } from '@api/activityCenter/activityCenter'
import { getToken } from '@utils'
export default {
  data() {
    return {
      text: '点击上传',
      loading: false,
      disabled: false,
      uploadFileByContentType,
      uploadFileByContentType2,
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      name: '新增',
      drawer: false,
      areaList: [],
      ruleform: {
        assemblyName: '', // 视频名称
        areaCode: '', // 活动区域
        videoTime: '' // 视频时间
      },
      ruleform1: {
        id: '',
        areaCode: '',
        assemblyName: '',
        imageName: '',
        imageUrl: '',
        fileUrl: '',
        fileName: '',
        note: ''
      },
      rules: {
        assemblyName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: '请选择区域', trigger: 'change' }
        ],
        imageUrl: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],
        fileUrl: [{ required: true, message: '请上传文件', trigger: 'change' }]
      },
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0,
      hideUpload: false,
      fileList: [],
      fileList1: [],
      dialogVisible: false,
      time: null
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getArea()
  },
  mounted() {
    this.listLiveData()
  },
  beforeDestroy() {
    clearInterval(this.time)
  },
  methods: {
    handleClose() {
      this.ruleform1 = {
        id: '',
        areaCode: '',
        assemblyName: '',
        imageName: '',
        imageUrl: '',
        fileUrl: '',
        fileName: '',
        note: ''
      }
      this.fileList = []
      this.fileList1 = []
      this.$refs.ruleform1.clearValidate()
      this.drawer = false
    },
    /** 获取丽水市以及各个区县 */
    getArea() {
      getArea({}).then(res => {
        if (res.data.code == '0000') {
          this.areaList = res.data.data || []
          this.ruleform.areaCode =
            this.areaList.length == 1 ? this.areaList[0].code : ''
          this.ruleform1.areaCode = this.ruleform.areaCode
          this.disabled = this.areaList.length == 1
        }
      })
    },
    // 视频名称
    getSearch() {
      this.currentPage = 1
      this.listLiveData()
    },
    // 所有类别
    getPoss() {
      this.currentPage = 1
      this.listLiveData()
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.listLiveData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listLiveData()
    },
    // 新增
    add() {
      console.log(this.ruleform1)
      this.drawer = true
      this.name = '新增'
    },
    edit(id) {
      this.drawer = true
      this.name = '编辑'
      getAssemblyById({ id: id }).then(res => {
        if (res.data.code == '0000') {
          this.ruleform1 = { ...res.data.data }
          this.ruleform1.id = id
          this.fileList = [{ name: '', url: this.ruleform1.imageUrl }]
          this.fileList1 = [
            { name: this.ruleform1.fileName, url: this.ruleform1.fileUrl }
          ]
        }
      })
    },
    // 列表
    listLiveData() {
      let par = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        assemblyName: this.ruleform.assemblyName,
        areaCode: this.ruleform.areaCode,
        startTime: this.ruleform.videoTime ? this.ruleform.videoTime[0] : '',
        endTime: this.ruleform.videoTime ? this.ruleform.videoTime[1] : ''
      }
      listAssemblyData(par).then(res => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData = list.results || []
          this.totalRecord = list.totalRecord || 0
        }
      })
    },

    // 删除
    deleteEntTrain(id) {
      this.$confirm('是否确定删除活动列表数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        deleteAssembly({ id: id }).then(res => {
          if (res.data.code == '0000') {
            this.$message.success('删除成功')
            this.listLiveData()
          } else {
            this.$message.error(res.data.msg || '删除失败')
          }
        })
      })
    },
    handleChange(file, fileList) {
      this.hideUpload = fileList.length >= 1
      console.log(this.hideUpload)
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return isLt2M
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      this.hideUpload = fileList.length >= 1
      this.ruleform1.imageUrl = ''
    },
    handleRemove1(file, fileList) {
      this.ruleform1.fileUrl = ''
      this.ruleform1.fileName = ''
    },
    docSuccess(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleform1.imageUrl = response.data.ossUrl
        this.$refs.imageId.clearValidate()
      }
      // this.$refs.form.clearValidate('imageId')
    },
    docSuccess1(response, file, fileList) {
      if (response.code == '0000') {
        if (response.data) {
          this.loading = true
          this.text = '上传中'
          this.$message('文件上传中，请等待。。。')
          this.getUploadProcess(response.data)
        }
      } else {
        this.$message.error(response.msg)
      }
    },
    getUploadProcess(key) {
      getUploadProcess({ key: key }).then(res => {
        if (res.data.code == '0000') {
          if (res.data.data) {
            this.$message.success('文件上传成功')
            this.ruleform1.fileName = res.data.data.fileName
            this.ruleform1.fileUrl = res.data.data.ossUrl
            clearInterval(this.time)
            this.time = null
            this.loading = false
            this.text = '点击上传'
            this.$refs.fileId.clearValidate()
          } else {
            if (!this.time) {
              this.time = setInterval(() => {
                this.getUploadProcess(key)
              }, 3000)
            }
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    beforeAvatarUpload1(file) {
      const isLt2M = file.size / 1024 / 1024 < 500
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 500MB!')
      }
      return isLt2M
    },
    handleExceed() {
      this.$message.warning('当前限制选择 1 个文件，已上传了1个文件')
    },
    submitForm(formName) {
      console.log(this.ruleform1)
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = { ...this.ruleform1 }
          data.areaName = this.areaList.filter(item => {
            return item.code == data.areaCode
          })[0].county
          updateOrInsertAssembly(data).then(res => {
            if (res.data.code == '0000') {
              this.$message.success(res.data.msg)
              this.handleClose()
              this.listLiveData()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    operationTopping(id, statue) {
      let text = statue ? '取消置顶' : '置顶'
      updateTopOperate({ id, isTop: statue ? 0 : 1 }).then(res => {
        if (res.data.code == '0000') {
          this.listLiveData()
          this.$message.success(text + '成功')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item {
  margin-bottom: 15px;
}
/deep/ .el-textarea__inner {
  min-height: 70px !important;
}
/deep/ .el-drawer__wrapper {
  .el-drawer__header {
    padding: 15px 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    margin-bottom: 0;
  }
  .el-drawer__header {
    font-size: 16px;
  }
  .el-drawer__body {
    padding: 20px;
    overflow: hidden;
    overflow-y: scroll;
  }
}
.header {
  display: flex;
  margin-bottom: 20px;
  .header-serach {
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
  .addPru {
    width: 100px;
    display: inline-block;
    text-align: center;
    position: absolute;
    right: 50px;
    height: 36px;
    border-radius: 5px;
    line-height: 36px;
    font-size: 16px;
    background: #1890ff;
    color: #fff;
    cursor: pointer;
  }
}
.actcolor {
  color: #1890ff;
}
.nocolor {
  color: rgba(0, 0, 0, 0.3);
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
.sharing-code {
  display: flex;
  span {
    line-height: 34px;
  }
  /deep/.el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  /deep/.el-button--medium {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.exhibition {
  // margin-top: 20px;
  margin-left: -25px;
  display: flex;
  #qrcode {
    width: 125px;
    height: 150px;
    margin: 20px auto;
  }
  .refreshs {
    margin: 20px auto;
    span {
      margin-left: 22px;
    }
    .refresh {
      margin-left: 50px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
.el-popover {
  min-width: 100px !important;
}
</style>
